/**
 * Logout Manager
 *
 * Manages logout functionality for API error handling.
 * This allows the API client to trigger logout without React dependencies.
 */

import { resetApiVerification } from "./api-verification-manager";

let logoutHandler: (() => Promise<void>) | null = null;

/**
 * Set the logout handler function
 * This should be called from the auth provider to provide access to Kinde's logout
 */
export const setLogoutHandler = (handler: () => Promise<void>) => {
	logoutHandler = handler;
};

/**
 * Trigger logout
 * Called when API returns 401 or 403
 */
export const triggerLogout = async (): Promise<void> => {
	// Reset API verification state
	resetApiVerification();

	if (!logoutHandler) {
		console.warn("Logout handler not set");
		return;
	}
	try {
		await logoutHandler();
	} catch (error) {
		console.error("Error during logout:", error);
	}
};
